import type {
  StandardReport,
  StandardState,
  SelectOption,
} from '@/models/externalReports/standard/spStandardReport';
import {
  timeIntegerToSeconds,
  unpackTimeInteger,
} from '@/lib/dateTimeHelper';
import type { ExternalReportsLabelSp } from '@/models/apis/externalReports/external_report_settings';
import { CONNECTION_CHAR_FOR_JOIN_ROADS_CONTENTS } from '@/consts/externalReports/standard';

export const initStandardReport = (): StandardReport => {
  return {
    id: 0,
    group1Id: 0,
    standardCarId: 0,
    baseDepartureTs: null,
    operationStartTs: null,
    operationEndTs: null,
    baseArrivalTs: null,
    hanName: null,
    contents: null,
    otherContent: null,
    roadNames: null,
  };
};

export const initCommonState = (): StandardState => {
  return {
    baseDepartureTime: null,
    workStartTime: null,
    workEndTime: null,
    currentTime: null,
    carUpdateTimer: null,
    workElapsedTimeNotifyTimer: null,
    mtxStoreTimer: null,
    mtxCreateTimer: null,
    status: 'stopped',
    standardCar: {
      id: 0,
      report: initStandardReport(),
    },
    standardMtxs: [],
    lastStandardMtxTs: null,
    errorModalMsg: '',
    isRequesting: false,
    showErrorModal: false,
    showGeolocationGeneralErrorMsg: false,
    showGeolocationPermissionErrorModal: false,
    externalReportSpLabels: {
      title: {},
      button: {},
      status: {},
      field_label: {},
    } as ExternalReportsLabelSp,
    currentScreenOverride: null,
  };
};

export const notifyWorkElapsedTimeSpeech = (workElapsedTimeInt: number, doSpeech: ((text: string) => void)): void => {
  // 15分毎に経過時間を通知する
  const thres = 900; // seconds
  const workElapsedTimeSec = timeIntegerToSeconds(workElapsedTimeInt);
  if (workElapsedTimeSec === 0) { return; }
  if (workElapsedTimeSec % thres > 0) { return; }

  const [h, m, s] = unpackTimeInteger(workElapsedTimeInt);
  let text = '作業開始から';
  if (h > 0) {
    text += `${h}時間`;
  }
  if (m > 0) {
    text += `${m}分`;
  }
  if (s > 0) {
    text += `${s}秒`;
  }
  text += 'が経過しました。';
  doSpeech(text);
};

export const parseSelectionOptions = (items: string, choices: string[]): SelectOption[] => {
  return items.split(CONNECTION_CHAR_FOR_JOIN_ROADS_CONTENTS)
    .map(name => {
      const index = choices.findIndex(choice => choice === name);
      return index > -1 ? { id: index, name } : null;
    })
    .filter((item): item is SelectOption => item !== null);
};
